export type { IButtonTypes, IButtonProps } from './Button';
export { ButtonSizeTypes, ButtonStyleTypes } from './enums';

import { Button as ButtonComp, ButtonDestructive, ButtonNaked, ButtonNeutral, ButtonPrimary } from './Button';

function buildButtonExport() {
  return Object.assign(ButtonComp, {
    Destructive: ButtonDestructive,
    Naked: ButtonNaked,
    Neutral: ButtonNeutral,
    Primary: ButtonPrimary
  });
}

export const Button = buildButtonExport();
